const formartOnlyNumber = (number) => {
  if (!number) {
    return '';
  }

  const value = number.match(/\d+/g);

  if (value) {
    return value.join('');
  }

  return '';
};

export default formartOnlyNumber;
